// A missing, empty or unparseable time counts as "not submitted".
export function submittedAt(ts?: string): string | undefined {
  if (!ts || Number.isNaN(new Date(ts).getTime())) return undefined;
  return ts;
}
